import { Volume2, Speaker, Building2, Heart, Projector, Settings } from 'lucide-react';
import { services } from '../data/mock';

const iconMap = {
  Volume2,
  Speaker,
  Building2,
  Heart,
  Projector,
  Settings,
};

export const ServicesSection = () => {
  return (
    <section id="services" className="relative py-28 bg-zinc-950">
      {/* Subtle bg decoration */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#50ced4]/20 to-transparent" />

      <div className="max-w-7xl mx-auto px-6">
        {/* Section header */}
        <div className="max-w-2xl mb-16">
          <span className="text-[#50ced4] text-sm font-medium tracking-widest uppercase mb-4 block">What We Offer</span>
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-5 leading-tight">
            Everything You Need for{' '}
            <span className="text-[#50ced4]">Amazing Sound</span>
          </h2>
          <p className="text-zinc-400 text-lg leading-relaxed">
            From intimate house parties to large corporate events, we provide professional audio equipment that delivers crystal-clear sound every time.
          </p>
        </div>

        {/* Services grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div
                key={service.id}
                className="group relative p-7 rounded-2xl bg-zinc-900/50 border border-white/5 hover:border-[#50ced4]/30 transition-all duration-500 hover:-translate-y-1"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                {/* Icon */}
                <div className="w-12 h-12 rounded-xl bg-[#50ced4]/10 flex items-center justify-center mb-5 group-hover:bg-[#50ced4]/20 transition-colors duration-300">
                  {IconComponent && <IconComponent className="w-6 h-6 text-[#50ced4]" />}
                </div>

                {/* Content */}
                <h3 className="text-lg font-semibold text-white mb-3 group-hover:text-[#50ced4] transition-colors">
                  {service.title}
                </h3>
                <p className="text-zinc-500 text-sm leading-relaxed">
                  {service.description}
                </p>

                {/* Hover glow */}
                <div className="absolute inset-0 rounded-2xl bg-[#50ced4]/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500 -z-10" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
